import React, { useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Shipping from "../../pages/store/Shipping";
import Payment from "../../pages/store/Payment";
import CheckoutAuth from "../../pages/store/CheckoutAuth";
import ProtectedStore from "../other/ProtectStore";
import Success from "../../pages/store/Success";

const CheckoutForm = () => {
  const [address, setAddress] = useState(null);
  return (
    <Switch>
      {/**If cart is empty redirect to the checkout page */}
      {/* {state.length < 1 && <Redirect to="/cart" />} */}
      <Route path="/checkout/auth" render={() => <CheckoutAuth />} />
      {/**If user does not provide email or authentication then redirect here */}
      {/**Route to shipping */}
      <ProtectedStore
        path="/checkout/shipping"
        render={() => <Shipping setAddress={setAddress} />}
      />
      {/**Route to Payment */}
      <ProtectedStore
        path="/checkout/payment"
        render={() => <Payment address={address} />}
      />
      <Route path="/checkout/success" component={Success} />
      <Redirect exact from="/checkout" to="/checkout/auth" />
    </Switch>
  );
};

export default CheckoutForm;
